import { useCallback, useMemo } from 'react';
import { shallowEqual, useDispatch, useSelector } from 'react-redux';
import { createSelector } from '@reduxjs/toolkit';

/**
 * Dispatch function to be called
 * to make use of the memo function if needed
 * @param {string} type
 */

export function useDispatchToProps(type) {
  const dispatch = useDispatch();
  const handleDispatch = (payload) => {
    dispatch({ type, payload });
  };
  return useCallback(handleDispatch, [type]);
}

/**
 * MapStateToProps to be called
 * that makes a shallow compare to
 * avoid unnecessary re-renders
 * @param {*} selection - Selector function that takes state and returns derived data
 * @param equality - Comparison function to determine if state has changed
 */

export function useStateToProps(selection, equality = shallowEqual) {
  // Memoize the selector to prevent new object references on each render
  const memoizedSelector = useMemo(() => {
    // If the selection is already a function and doesn't have a memoizedSelector property
    // (indicating it's not already memoized), then memoize it
    if (typeof selection === 'function' && !selection.memoizedSelector) {
      return createSelector([(state) => state], selection);
    }
    // Otherwise return the selection as is (either a non-function or already memoized)
    return selection;
  }, [selection]);

  return useSelector(memoizedSelector, equality);
}

export default {};
